/**
 * Root component that wraps the entire application.
 *
 * Provides the safe-area shell for iOS notch and home bar handling.
 * Currently mounts Dashboard directly. As routing is added, this
 * becomes the layout wrapper around a router outlet.
 *
 * Consumed by entrypoints/main.tsx.
 */
import { Dashboard } from "./dashboard/Dashboard";

export function App() {
  return (
    <div className="app-shell flex flex-col">
      <Dashboard />
    </div>
  );
}
